import { incYenOf } from '../../../lib/pricing';
const coursesMaster = {
  // page.tsx JSON-LD
  'coursesMaster.jsonld.breadcrumb.home': 'ホーム',
  'coursesMaster.jsonld.breadcrumb.courses': 'コース紹介',
  'coursesMaster.jsonld.breadcrumb.current': 'マスターコース',
  'coursesMaster.jsonld.course.name': 'マスターコース',
  'coursesMaster.jsonld.course.description': '管理能力・危機対応・VIP対応までを3ヶ月・96時間で修めるプロフェッショナル養成の最上級課程。エッセンシャル・アドバンスの全内容を含む統合課程。全日本執事協会運営。',
  'coursesMaster.jsonld.provider': '一般社団法人全日本執事協会',
  'coursesMaster.lastUpdated': '最終更新: 2026年6月15日',
  'coursesMaster.backToTop': 'ページトップへ戻る',

  // HeroSection
  'coursesMaster.hero.homeLink': 'ホーム',
  'coursesMaster.hero.coursesLink': 'コース紹介',
  'coursesMaster.hero.currentPage': 'マスターコース',
  'coursesMaster.hero.title': 'マスターコース',
  'coursesMaster.hero.titleEn': 'MASTER COURSE',
  'coursesMaster.hero.lead': 'マスターコースは、管理能力・危機対応・VIP対応までを3ヶ月・96時間で修めるプロフェッショナル養成の最上級課程です。執事養成に特化した執事学校の最上級課程として、VIP対応に必要な高度な判断力まで体系的に修めます。',
  'coursesMaster.hero.imgAlt': '大理石の邸宅ロビーに立つ燕尾服の日本人シニア執事 - マスターコース',
  'coursesMaster.hero.imgTitle': '日本執事アカデミー マスターコース',

  // HeroSection trust badges
  'coursesMaster.badge.0': '最上級課程・96時間',
  'coursesMaster.badge.1': '専門家マスタークラス2回',
  'coursesMaster.badge.2': '認定マスターバトラー授与',
  'coursesMaster.badge.3': 'エッセンシャル・アドバンスの全内容を含みます',

  // CourseOverview
  'coursesMaster.overview.label': 'COURSE OVERVIEW',
  'coursesMaster.overview.title': 'コース概要',
  'coursesMaster.overview.colItem': '項目',
  'coursesMaster.overview.colContent': '内容',
  'coursesMaster.overview.rowDuration': '期間',
  'coursesMaster.overview.rowDays': '開催日数',
  'coursesMaster.overview.rowHours': '総時間',
  'coursesMaster.overview.rowPrice': '受講料',
  'coursesMaster.overview.rowSchedule': '開校時期',
  'coursesMaster.overview.rowFormat': '授業形式',
  'coursesMaster.overview.rowCapacity': '定員',
  'coursesMaster.overview.rowTarget': '対象',
  'coursesMaster.overview.valueDuration': '3ヶ月',
  'coursesMaster.overview.valueDays': '16日間',
  'coursesMaster.overview.valueHours': '96時間',
  'coursesMaster.overview.valuePrice': incYenOf('ac-master'),
  'coursesMaster.overview.priceFormat': '¥{price}（税込）',
  'coursesMaster.overview.valueSchedule': '2〜4月・9〜11月開校',
  'coursesMaster.overview.valueFormat': '土日開催・1日6時間（90分×4コマ）',
  'coursesMaster.overview.valueCapacity': '完全少人数制（定員6名）',
  'coursesMaster.overview.valueTarget': 'プロ志望者・管理職を目指す方（未経験者も直接受講可）',
  'coursesMaster.overview.note': '※表示価格はすべて税込です。開校日程の詳細は',
  'coursesMaster.overview.scheduleLink': '年間スケジュール',
  'coursesMaster.overview.noteSuffix': 'をご確認ください。',

  // TargetAudience
  'coursesMaster.target.label': 'WHO IS THIS FOR',
  'coursesMaster.target.title': 'こんな方におすすめ',
  'coursesMaster.target.lead': 'マスターコースはエッセンシャル・アドバンスの内容を含む統合課程のため、未経験の方も直接受講いただけます。中でもプロフェッショナルを真剣に目指す次のような方に特におすすめです',
  'coursesMaster.target.0': '執事として就業・独立を本気で目指す方',
  'coursesMaster.target.1': 'ホテル・レジデンスでバトラー部門の責任者を目指す方',
  'coursesMaster.target.2': '富裕層対応の総責任者として現職の価値を高めたい方',
  'coursesMaster.target.3': '海外水準の教育を離職せず国内で修めたい方',

  // LearningContent
  'coursesMaster.learning.label': 'CURRICULUM',
  'coursesMaster.learning.title': 'マスターコースで何が学べる？',
  'coursesMaster.learning.lead': '管理能力から危機対応・VIPサービスまで、6つの高度な領域を体系的に学びます。日本の執事学校で培うVIP対応の実践力は、修了後の現場でもそのまま活かせます。',
  'coursesMaster.learning.titleAlt': 'マスターコース修了後はどんな進路がある？',
  'coursesMaster.learning.leadAlt': 'エッセンシャル・アドバンスの全内容を含む統合課程として、管理職レベルの6領域を習得します',
  'coursesMaster.learning.imgAlt': 'マスターコース学習内容 - {title}の実習風景',
  'coursesMaster.learning.imgTitle': '日本執事アカデミー - {title}',
  'coursesMaster.learning.0.title': '執事としての管理能力',
  'coursesMaster.learning.0.titleEn': 'Household Management',
  'coursesMaster.learning.0.description': '家政全体の年間計画立案から、予算と物品の管理、外部業者との折衝まで、ハウスホールドマネジメントの実務を体系的に学びます。補助スタッフの配置計画や品質管理の仕組みづくりまで、管理職としての視座を養います。',
  'coursesMaster.learning.1.title': '危機対応とセキュリティ',
  'coursesMaster.learning.1.titleEn': 'Crisis & Security',
  'coursesMaster.learning.1.description': '急病・事故・不審者対応などの初動判断と、主およびゲストを守る安全管理の考え方を演習形式で学びます。実際の邸宅や施設を想定したシナリオ演習を通じて、冷静かつ的確な判断力を養います。',
  'coursesMaster.learning.2.title': '国際的なプロトコル',
  'coursesMaster.learning.2.titleEn': 'International Protocol',
  'coursesMaster.learning.2.description': '公式行事における席次・国旗・贈答の作法など、国際儀礼の基礎を習得します。実在の国際行事をケーススタディとして分析し、どのような場面でも適切な対応ができる判断基準を身につけます。',
  'coursesMaster.learning.3.title': 'VIPへの対応',
  'coursesMaster.learning.3.titleEn': 'VIP Service',
  'coursesMaster.learning.3.description': '著名人・要人の接遇において必須となる守秘義務、動線設計、先回りの準備といった高度なサービスの実践手法を学びます。過去の具体的な事例から、期待を超えるおもてなしの在り方を考察します。',
  'coursesMaster.learning.4.title': '特殊状況への対処法',
  'coursesMaster.learning.4.titleEn': 'Special Situations',
  'coursesMaster.learning.4.description': '想定外の要望や突発的なトラブルに対する判断基準と、複数の代替案を組み立てる思考法を習得します。実際に起きうる難易度の高いシチュエーションを題材に、現場で通用する実践的な問題解決力を養います。',
  'coursesMaster.learning.5.title': 'リーダーシップスキル',
  'coursesMaster.learning.5.titleEn': 'Leadership Skills',
  'coursesMaster.learning.5.description': '補助スタッフへの適切な指示と育成、チームで品質を保つ仕組みづくりなど、執事長としてのリーダーシップを学びます。講師自身の管理経験に基づく実践的なケーススタディを通じて、人を動かす力を養います。',

  // LearningProgression
  'coursesMaster.progression.label': 'LEARNING FLOW',
  'coursesMaster.progression.title': '学習の流れ',
  'coursesMaster.progression.lead': '3ヶ月・全16日間を通じて、エッセンシャル・アドバンスの内容を含めて段階的に学びます',
  'coursesMaster.progression.0.title': '1ヶ月目: エッセンシャルの内容を総復習',
  'coursesMaster.progression.0.description': '基本マナーとエチケット・日常的な家事管理・基本的なテーブルセッティング・紅茶とコーヒーの淹れ方・衣類の手入れ・基本的なコミュニケーション技術を通して復習し、確かな土台を固めます。',
  'coursesMaster.progression.1.title': '2ヶ月目: アドバンスの内容を発展学習',
  'coursesMaster.progression.1.description': '高度なサービス技術・ワインとスピリッツの知識・イベント計画と管理・国際的なマナーと文化理解・高級衣類のケアへと学びを広げます。',
  'coursesMaster.progression.2.title': '3ヶ月目: マスター専門領域を習得',
  'coursesMaster.progression.2.description': '執事としての管理能力・危機対応とセキュリティ・国際的なプロトコル・VIPへの対応・特殊状況への対処法・リーダーシップスキルを修め、最上級課程を完成させます。',
  'coursesMaster.progression.note': '※未経験からご入学の方も、この順で無理なく学べます。アドバンスコース修了者は1〜2ヶ月目を復習としてご活用いただけます。',

  // DailySchedule
  'coursesMaster.schedule.label': 'DAILY SCHEDULE',
  'coursesMaster.schedule.title': '1日の流れ',
  'coursesMaster.schedule.lead': '90分×4コマで構成される授業日（土曜または日曜）のタイムテーブル例です',
  'coursesMaster.schedule.note': '※上記は標準的なタイムテーブル例です。回により内容が前後する場合がございます。',
  'coursesMaster.schedule.0.time': '10:00 – 11:30',
  'coursesMaster.schedule.0.title': '理論講義',
  'coursesMaster.schedule.0.description': '管理論・危機対応・国際プロトコルなど、マスター課程にふさわしい高度な座学。実務経験豊富な講師がケーススタディを交えて講義します。',
  'coursesMaster.schedule.1.time': '11:45 – 13:15',
  'coursesMaster.schedule.1.title': '実技演習',
  'coursesMaster.schedule.1.description': '高度なサービス技術の実践。VIP対応やフォーマル行事のシミュレーションを、受講生お一人ずつ丁寧に指導します。',
  'coursesMaster.schedule.2.time': '13:15 – 14:00',
  'coursesMaster.schedule.2.title': '昼食休憩',
  'coursesMaster.schedule.2.description': '',
  'coursesMaster.schedule.3.time': '14:00 – 15:30',
  'coursesMaster.schedule.3.title': 'リーダーシップ演習',
  'coursesMaster.schedule.3.description': 'チーム指揮・指示出し・育成手法をロールプレイングで実践。管理職としての判断力と指導力を養います。',
  'coursesMaster.schedule.4.time': '15:45 – 17:15',
  'coursesMaster.schedule.4.title': '統合演習＋講評',
  'coursesMaster.schedule.4.description': '複数の技能を組み合わせた総合演習。講師による詳細なフィードバックと個別面談であなたの強みと課題を明確にします。',

  // MasterPrograms
  'coursesMaster.programs.label': 'EXCLUSIVE PROGRAMS',
  'coursesMaster.programs.title': 'マスターコース限定プログラム',
  'coursesMaster.programs.subtitleEn': 'Master Exclusive Programs',
  'coursesMaster.programs.lead': 'エッセンシャル・アドバンスにはない、マスターコースだけの4つの特別プログラムです',
  'coursesMaster.programs.0.titleEn': 'Expert Masterclass',
  'coursesMaster.programs.0.title': '外部専門家マスタークラス',
  'coursesMaster.programs.0.details': 'ソムリエ、危機管理、国際儀礼等の第一線で活躍する専門家を招いた特別講義を2回開催。現場でしか得られない知見を直接学べる貴重な機会です。',
  'coursesMaster.programs.0.note': '※講師は開校に向けて順次公開予定',
  'coursesMaster.programs.1.titleEn': 'Real Service Experience & Practical Exam',
  'coursesMaster.programs.1.title': '本物のサービスを体験する特別実習＋総合実技演習',
  'coursesMaster.programs.1.details': '一流ホテルやレストランで提供される本格的なサービスを、受講生がゲスト（お客様）として体験し、プロの所作・間合い・気配りを間近で観察して学びます。受け手の立場を知ることは、質の高いサービスを提供するうえで欠かせません。また最終日には、アカデミー内でこれまで学んだすべての技能を統合した総合実技演習を行います。これが修了実技試験を兼ね、学びの集大成となります。',
  'coursesMaster.programs.1.note': '※体験先は内容に応じてご案内します',
  'coursesMaster.programs.2.titleEn': 'Career Coaching',
  'coursesMaster.programs.2.title': '個別キャリアコーチング',
  'coursesMaster.programs.2.details': '講師との1対1面談を2回実施し、修了後の進路を一緒に設計します。進路に関するご相談・情報提供、独立開業のアドバイス、海外修行の情報提供など、あなたの目標に合わせた具体的なキャリアプランをお描きします。',
  'coursesMaster.programs.2.note': '※面談日程はコース期間内に調整',
  'coursesMaster.programs.3.titleEn': 'Tailored Vest',
  'coursesMaster.programs.3.title': 'オーダーメイドベスト',
  'coursesMaster.programs.3.details': '開校時に採寸を行い、コース中盤からご自身のベストを着用して学びます。制服を単なる衣服ではなく教育の一部と捉え、プロフェッショナルとしての自覚と誇りを身につけていただく本学院独自のプログラムです。',
  'coursesMaster.programs.3.note': '※採寸は開講初日に実施',

  // CertificationSection
  'coursesMaster.cert.label': 'CERTIFICATION',
  'coursesMaster.cert.title': '修了実技試験と認定資格',
  'coursesMaster.cert.titleEn': 'Certified Master Butler',
  'coursesMaster.cert.description': 'コース最終日に実施する総合実技演習（これまで学んだ全技能を統合した実演）と筆記試験に合格すると、本学院最高位の認定資格が授与されます。',
  'coursesMaster.cert.qualLabel': '取得資格',
  'coursesMaster.cert.qualification': '認定マスターバトラー（Certified Master Butler）',
  'coursesMaster.cert.badge': '認定ピンバッジ',
  'coursesMaster.cert.note': '※当資格は一般社団法人全日本執事協会が独自に認定する民間資格です。',

  // CourseBenefits
  'coursesMaster.benefits.label': 'BENEFITS',
  'coursesMaster.benefits.title': '受講特典',
  'coursesMaster.benefits.lead': 'マスターコース受講生の皆様に付帯する、最上級課程ならではの特典です',
  'coursesMaster.benefits.detailLink': '※特典の詳細は受講特典ページをご覧ください',
  'coursesMaster.benefits.0.title': 'オーダーメイドベスト',
  'coursesMaster.benefits.0.description': '開校時に採寸し、あなただけのベストを仕立てます。コース中盤から着用し、プロフェッショナルとしての自覚を高めます。',
  'coursesMaster.benefits.1.title': '全教科書セット（全15冊・E1〜E5+A1〜A5+M1〜M5）',
  'coursesMaster.benefits.1.description': 'E群・A群に加え、国際プロトコル・危機管理・VVIPサービスなどM群5冊を含む全15冊を進呈。',
  'coursesMaster.benefits.2.title': '高級懐中時計',
  'coursesMaster.benefits.2.description': '執事の象徴として、本学院オリジナルの懐中時計を進呈。修了後もプロフェッショナルとしての誇りを携えていただくための品です。',
  'coursesMaster.benefits.3.title': 'ワインオープナーセット',
  'coursesMaster.benefits.3.description': 'ソムリエナイフとウェイターズコークスクリューをセットで進呈。実習および修了後もご使用いただけます。',
  'coursesMaster.benefits.4.title': '基本的な執事道具セット',
  'coursesMaster.benefits.4.description': 'プロ仕様の基本ツール一式を進呈します。',
  'coursesMaster.benefits.5.title': '白手袋・オリジナルエプロン',
  'coursesMaster.benefits.5.description': '初日支給。実習時に着用するアカデミー特製エプロンと高品質な白手袋です。',

  // NextStep
  'coursesMaster.nextStep.label': 'NEXT STEP',
  'coursesMaster.nextStep.fromAdvanced': 'アドバンス',
  'coursesMaster.nextStep.toMaster': 'マスター',
  'coursesMaster.nextStep.title': '編入優遇制度',
  'coursesMaster.nextStep.description': 'マスターコースはアドバンスの内容を含むため、アドバンスコース修了者が本コースへ進む場合、重複する内容分の受講料180,000円が減額されます。二つの課程を経て、揺るぎないプロフェッショナルへと成長されることを期待しています。',
  'coursesMaster.nextStep.discountAmount': '180,000',
  'coursesMaster.nextStep.discountLabel': '減額: ¥{amount}',
  'coursesMaster.nextStep.viewAdvanced': 'アドバンスコースを見る',

  // OverseasComparison
  'coursesMaster.overseas.label': 'DOMESTIC ADVANTAGE',
  'coursesMaster.overseas.title': '海外で学ぶ場合との比較',
  'coursesMaster.overseas.body': '海外の全寮制執事養成学校では、8週間以上の長期にわたる離職と渡航が必要となり、現職を続けながらの受講は困難です。一方、本学院のマスターコースは土日のみの通学（16日間・3ヶ月）で設計されており、お仕事を継続しながら世界水準の執事教育を日本国内で修了することが可能です。また、渡航費や長期滞在費がかからないため、総費用の面でも合理的な選択肢となります。',
  'coursesMaster.overseas.highlight': '土日のみの通学（16日間・3ヶ月）',

  // AdmissionFlow
  'coursesMaster.admission.label': 'ADMISSION FLOW',
  'coursesMaster.admission.title': '受講までの流れ',
  'coursesMaster.admission.viewDetail': '詳細を見る',
  'coursesMaster.admission.0.titleEn': 'Brochure',
  'coursesMaster.admission.0.title': '資料請求',
  'coursesMaster.admission.0.description': 'まずは資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお送りします。',
  'coursesMaster.admission.1.titleEn': 'Consultation',
  'coursesMaster.admission.1.title': '個別相談（推奨）',
  'coursesMaster.admission.1.description': '高額講座のため、個別相談を推奨しています。経験豊富なスタッフが、あなたの目標やご経験に合わせた最適な進路を提案します。',
  'coursesMaster.admission.2.titleEn': 'Apply',
  'coursesMaster.admission.2.title': 'お申込み',
  'coursesMaster.admission.2.description': 'コースが決まりましたら、所定の申込フォームよりお手続きください。定員になり次第締切となります。',
  'coursesMaster.admission.3.titleEn': 'Confirmation',
  'coursesMaster.admission.3.title': '受講確定',
  'coursesMaster.admission.3.description': 'お申込み受付後、受講確定のご案内と事前準備資料をお送りします。開講初日には採寸も行います。',

  // CTASection
  'coursesMaster.cta.label': 'TAKE THE NEXT STEP',
  'coursesMaster.cta.title': 'まずは個別相談から',
  'coursesMaster.cta.lead': 'マスターコースは最上級課程のため、個別相談でご経験や目標をうかがい、最適な受講プランをご提案いたします。まずはお気軽にご予約ください。',
  'coursesMaster.cta.consultation': '個別相談を予約する（推奨）',
  'coursesMaster.cta.brochure': '資料請求はこちら（無料）',
  'coursesMaster.cta.note': '※アドバンス修了者の編入優遇は申込時にお申し出ください',

  // RelatedPages
  'coursesMaster.related.label': 'RELATED',
  'coursesMaster.related.title': '関連ページ',
  'coursesMaster.related.viewDetail': '詳しく見る',
  'coursesMaster.related.0.title': 'エッセンシャルコース',
  'coursesMaster.related.0.description': '基礎から始める入門課程',
  'coursesMaster.related.1.title': 'アドバンスコース',
  'coursesMaster.related.1.description': '専門技能を磨く中級課程',
  'coursesMaster.related.2.title': 'コース比較',
  'coursesMaster.related.2.description': '3コースの違いを一覧で確認',
  'coursesMaster.related.3.title': '年間スケジュール',
  'coursesMaster.related.3.description': '開校時期と授業日程のご案内',
  'coursesMaster.related.4.title': '料金詳細',
  'coursesMaster.related.4.description': '受講料に含まれるものの内訳',
  'coursesMaster.related.5.title': 'カリキュラム',
  'coursesMaster.related.5.description': '学ぶ内容の全体像を確認',

  // FAQSection
  'coursesMaster.faq.label': 'FAQ',
  'coursesMaster.faq.title': 'よくあるご質問',
  'coursesMaster.faq.0.question': '未経験でも直接マスターコースに申し込めますか？',
  'coursesMaster.faq.0.answer': 'はい、お申込みいただけます。本コースはエッセンシャル・アドバンスの内容を含む統合課程のため、未経験の方も基礎から順に学べます。最適な学び方は個別相談でもご提案いたします。',
  'coursesMaster.faq.1.question': '総合実技演習とは何ですか？',
  'coursesMaster.faq.1.answer': 'アカデミー内で、これまで学んだ全技能を統合した総合実技演習です。これが修了実技試験を兼ね、合格者に「認定マスターバトラー」を授与します。',
  'coursesMaster.faq.2.question': '支払い方法を教えてください。',
  'coursesMaster.faq.2.answer': '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
};

export default coursesMaster;
